"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSecondLevelDomain = void 0;
const getSecondLevelDomain = () => {
    const [first, second] = window.location.host.split('.').reverse();
    return `${second ? `${second}.` : ''}${first}`;
};
exports.getSecondLevelDomain = getSecondLevelDomain;
